import React from 'react'
import { SpaceProps, LayoutProps } from 'styled-system'
import Icons from '../../Icons'
import { ColorsMap } from '@/utils/Theme'
import { StyledSelect, IconWrapper, Wrapper, Label } from './SelectStyles'

export interface SelectProps extends SpaceProps, LayoutProps {
  name?: string
  id?: string
  label?: any
  disabled?: boolean
  onChange?: (e: any) => any
}

export const Select: React.FC<SelectProps> = ({ children, label, id, disabled = false, onChange, ...props }) => (
  <Wrapper {...props}>
    <Label>{label}</Label>
    <StyledSelect id={id} onChange={onChange} disabled={disabled}>
      {children}
    </StyledSelect>
    <IconWrapper>
      <Icons.ChevronDown size="l" color={ColorsMap.brownishGrey} />
    </IconWrapper>
  </Wrapper>
)
